import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@my-scoot/component-library-legacy";

export const SeeMoreModal = ({ record, columns = [] }) => {
  if (!record) return null;

  const modalContent = columns
    .filter(
      (column) => !column.hiddenInDetails && !column.hidden && column.headerName
    )
    .map((column) => {
      let value = record[column.field];

      if (column.valueFormatter) {
        value = column.valueFormatter(record);
      }

      if (value === undefined || value === null || value === "") {
        value = column.emptyField || "N/A";
      }

      return {
        title: column.headerName,
        value,
        info: column.info,
      };
    });

  return (
    <div className="tw-py-3">
      {modalContent.map((item, index) => (
        <React.Fragment key={item.title}>
          <div className="tw-flex tw-justify-between tw-gap-3 tw-text-sm">
            <span className="tw-font-medium">{item.title}</span>

            <div className="tw-flex tw-items-center tw-gap-1">
              <div className="tw-text-right">{item.value}</div>

              {item.info && (
                <Tooltip
                  arrow
                  color="primary"
                  placement="top"
                  title={item.info}
                >
                  <InfoOutlinedIcon
                    className="tw-text-[#8A8A8A]"
                    style={{
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              )}
            </div>
          </div>

          {index < modalContent.length - 1 && (
            <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-my-[10px]" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
